import classNames from 'classnames';
import { t } from 'ttag';


import s from './ProductDetailsProductStats.sss';

interface Props {
  className?: string,
  impressionsCount: number,
  paidImpressionsCount: number,
  viewsCount: number,
  likesCount: number,
  availabilityCount: number,
}

export const ProductDetailsProductStats: React.FC<Props> = ({
  className,
  impressionsCount,
  paidImpressionsCount,
  viewsCount,
  likesCount,
  availabilityCount,
}) => {
  return (
    <ul className={classNames(s.list, className)}>
      <li className={s.item}>
        <span className={s.label}>
          {t`Безкоштовних показів:`}
        </span>
        <span className={s.value}>
          {impressionsCount}
        </span>
      </li>

      <li className={s.item}>
        <span className={s.label}>
          {t`Рекламних показів:`}
        </span>
        <span className={s.value}>
          {paidImpressionsCount}
        </span>
      </li>

      <li className={s.item}>
        <span className={s.label}>
          {t`Переглядів:`}
        </span>
        <span className={s.value}>
          {viewsCount}
        </span>
      </li>

      <li className={s.item}>
        <span className={s.label}>
          {t`Подобається:`}
        </span>
        <span className={s.value}>
          {likesCount}
        </span>
      </li>

      <li className={s.item}>
        <span className={s.label}>
          {t`Наявність:`}
        </span>
        <span className={s.value}>
          {availabilityCount}
        </span>
      </li>
    </ul>
  );
};
